import { createStore, applyMiddleware, compose as simpleCompose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { makeApiCall } from '~/utils';

import { history } from "~/router/history";
import rootReducer from './reducers';
import rootSaga from './sagas';
import apiMiddleware from './middleware/api-call';
import websockets from './middleware/socket';

import { routerMiddleware } from 'connected-react-router';
import Cookies from "js-cookie";
import {BEARER_NAME} from "~/config/constants";
import Echo from './middleware/socket/echo'

const sagaMiddleware = createSagaMiddleware();

const middleware = applyMiddleware(
    apiMiddleware(makeApiCall),
    sagaMiddleware,
    websockets(),
    routerMiddleware(history),
    createLogger({
        collapsed: true,
    }),
);

const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || simpleCompose;

const getStore = (initialState = {}) => {
    const store = createStore(
        rootReducer(history),
        initialState,
        compose(middleware)
    );
    sagaMiddleware.run(rootSaga);

    return store;
};

export default getStore;
